import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'search-toggle_saving_filters-click';
/**
 * Fired when a user toggles saved filters in search on&#x2F;off
 */
export function trackSearchToggleSavingFiltersClick(Value) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { Value },
    });
}
